import { companyRefDataSource } from '../state/company-datasource'

/**
 * Shared company reference data for select/combobox pickers. All callers share
 * one module-level cache (see `state/company-datasource.ts`).
 */
export function useSelectCompanyDataSource() {
  return {
    companies: companyRefDataSource.items,
    loadingCompanies: companyRefDataSource.loading,
    fetchCompanies: companyRefDataSource.fetch
  }
}
